import { inject } from '@angular/core';
import { CanActivateFn, UrlSerializer } from '@angular/router';
import { of } from 'rxjs';

export const legacySlugGuard: CanActivateFn = (route, state) => {
  const serializer = inject(UrlSerializer);

  // preserve query params
  const qp = route.queryParams ?? {};
  const qs = Object.keys(qp).length ? `?${new URLSearchParams(qp as Record<string, string>).toString()}` : '';

  // accept both :companyslug and :companySlug for safety
  const companySlug =
    route.paramMap.get('companyslug') ?? route.paramMap.get('companySlug') ?? route.paramMap.get('slug');

  if (!companySlug) return true; // not our pattern → continue normal routing

  return of(serializer.parse(`/steps/${companySlug}/undefined/shopping-cart-step${qs}`));
};
